var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBag20Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.485 7.46a.2.2 0 0 1 .193-.25h13.41a.2.2 0 0 1 .193.25L15 16.167a1.2 1.2 0 0 1-1.16.896H6.925a1.2 1.2 0 0 1-1.16-.896L3.485 7.46Z",
  stroke: "#64748B",
  strokeWidth: 1.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m6.383 8.73.9-4.401a2 2 0 0 1 1.96-1.599h2.152a2 2 0 0 1 1.948 1.545l1.04 4.455",
  stroke: "#64748B",
  strokeWidth: 1.6,
  strokeLinecap: "round"
})));
export default SvgBag20Px;